/** @jsxImportSource ./simboluri-jsx */
import { t, tx, useT } from "../i18n";
import type { Cheie } from "../i18n";
// Îmbunătățiri viitoare — lista de lucru de după Pasul 19.
//
// Lista se ÎNTREȚINE AICI (nu vine dintr-un pas al pipeline-ului): când o
// idee se implementează, elementul ei se șterge; când apare una nouă, se
// adaugă un element cu context suficient cât să poată fi reluată oricând.

type Idee = {
  titlu: Cheie;
  descriere: Cheie;
  categorie: "performanță" | "optimizator" | "verificări" | "încărcări";
};

// Cheile, nu textele: `t` se cheamă la randare, ca lista să urmeze limba.
const CATEGORII: Record<Idee["categorie"], Cheie> = {
  "performanță": "struct.imb.cat_performanta",
  "optimizator": "struct.imb.cat_optimizator",
  "verificări": "struct.rzv.verificari",
  "încărcări": "struct.imb.cat_incarcari",
};

const IDEI: Idee[] = [
  {
    categorie: "performanță",
    titlu: "struct.imb.mesh_grosier_lanturile",
    descriere: "struct.imb.h_mesh_02",
  },
  {
    categorie: "optimizator",
    titlu: "struct.imb.mutarea_unui_stalp",
    descriere: "struct.imb.mutarea_a_lungul2",
  },
  {
    categorie: "optimizator",
    titlu: "struct.imb.unirea_a_doi",
    descriere: "struct.imb.parghia_lipseste_grinzil2",
  },
  {
    categorie: "verificări",
    titlu: "struct.imb.reducerea_ec2_6",
    descriere: "struct.imb.stalp_plantat_cade2",
  },
  {
    categorie: "optimizator",
    titlu: "struct.imb.excentricitatea_cm_cr",
    descriere: "struct.imb.calculeaza_raporteaza_de2",
  },
  {
    categorie: "verificări",
    titlu: "struct.imb.driftul_nivel_sls",
    descriere: "struct.imb.deplasarile_relative_niv2",
  },
  {
    categorie: "verificări",
    titlu: "struct.imb.ks_recalculat_reimpus",
    descriere: "struct.imb.abaterea_peste_202",
  },
  {
    categorie: "încărcări",
    titlu: "struct.imb.vantul_cr_1",
    descriere: "struct.imb.inca_incarcare_deci2",
  },
];

export default function Imbunatatiri() {
  useT();
  const categorii = Array.from(new Set(IDEI.map((i) => i.categorie)));
  return (
    <div className="pj-step-page">
      <h2>{t("struct.imb.imbunatatiri_viitoare")}</h2>
      <p className="st-card-sub" style={{ maxWidth: 640, marginBottom: 18 }}>
        {tx("struct.imb.intro")}
      </p>
      {categorii.map((cat) => (
        <div key={cat} style={{ marginBottom: 20 }}>
          <h3 style={{ fontSize: 14, margin: "0 0 10px", textTransform: "capitalize" }}>
            {t(CATEGORII[cat])}
          </h3>
          <div className="st-cards">
            {IDEI.filter((i) => i.categorie === cat).map((i) => (
              <div key={i.titlu} className="st-card" style={{ maxWidth: 460 }}>
                <div className="st-card-label">{t(i.titlu)}</div>
                <div className="st-card-sub" style={{ maxWidth: "none", marginTop: 6 }}>
                  {t(i.descriere)}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
